import { Component, OnInit, Input } from '@angular/core';
import { ModalComponent } from '../modal.component';
import { ModalService } from '../../../services/modal/modal.service';
import { AppSettingsService } from '../../../services/app-settings/app-settings.service';
import { UpaService } from '../../../services/upa/upa.service';
import { GenericEvent } from '../../../models/genericEvent';
import { PriceboxData } from 'src/app/shared/models/domain/pricebox-data';
import { Price } from 'src/app/shared/models/domain/price';
import { PriceDetailModal } from 'src/app/shared/models/domain/price-detail-modal';
import { RedemptionInfo } from 'src/app/shared/models/domain/loyalty/redemptionInfo';
import {LoyaltyMode} from '@shopping-angular-components/loyalty';

@Component({
  selector: 'price-detail-modal',
  templateUrl: './price-detail-modal.component.html',
  styleUrls: ['./price-detail-modal.component.scss'],
})
export class PriceDetailModalComponent extends ModalComponent implements OnInit {
  @Input() price: Price;
  @Input() serviceTypeMessage: string; //TODO: Tipo de servicio: "Private", "Shared", etc.
  @Input() currencySymbol: string;
  @Input() discountByDealEnabled: boolean;
  @Input() loyaltyMode: LoyaltyMode;
  @Input() discountByDealPaymentMethods: string;
  @Input() redemptionDescription: string;
  @Input() redemptionInfo: RedemptionInfo;

  priceDetailModal: PriceDetailModal;
  public wasOpened: boolean = false;

  constructor(
    protected modalService: ModalService,
    private appSettingsService: AppSettingsService,
    private upaService: UpaService
  ) {
    super(modalService);
  }

  ngOnInit() {
    // Initialize component logic here
  }

  onShow() {

      this.configurePriceDetailModal();
    super.onShow();
    this.wasOpened = true;
    this.trackUpaPriceDetailEvt();
  }

  private trackUpaPriceDetailEvt(): void {
    this.upaService.track(GenericEvent.newUserAction('showPriceDetail', 'click', {
      channel: this.appSettingsService.getChannel(),
      site: this.appSettingsService.getSite(),
      lang: this.appSettingsService.getLanguage(),
      userId: this.appSettingsService.getUserId()
    }));
  }

  private configurePriceDetailModal() {
      this.priceDetailModal = {
          basePrice : this.price.basePrice,
          taxAmount : this.price.taxAmount,
          totalPrice : this.isRedemptionEnabled() ? this.redemptionInfo.toPay : this.price.totalPrice,
          redemptionDiscount : this.isRedemptionEnabled() ? this.redemptionInfo.saved : null
      };

      if (this.discountByDealEnabled) {
          this.priceDetailModal.discountByDeal = this.price.discountByDeal;
          this.priceDetailModal.totalPriceWithDeal = this.isRedemptionEnabled() ? this.redemptionInfo.toPayWithDeal : this.price.totalCostWithDeal;
      }
  }

    public isRedemptionEnabled(): boolean {
        return !!this.redemptionInfo && this.loyaltyMode === LoyaltyMode.REDEMPTION;
    }


}
